import React, { Component } from "react";
import { Card } from "antd";
import "../chat/styles.css";
import "../chat/chat.style.css";
import "axios";
import Chatbox from './walkinchatbox';
import { LanguageContext } from "../../context/LanguageContext";
import "./wk.style.css";

export default class walkinchat extends Component {
    static contextType = LanguageContext;
    currentLanguage = null;

    constructor(props) {
        super(props);
        this.state = {
            isHovered: false,
        };
    }

    render() {
        return (
            <div className="wk-menu-section" onMouseEnter={() => this.setState({ isHovered: true })} onMouseLeave={() => this.setState({ isHovered: false })}>
                <Card className={`wk-menu-card ${this.state.isHovered ? "wk-card-hovered" : ""}`}>
                    <div className="wk-chatbox">
                        <Chatbox />
                    </div>
                </Card>
            </div>
        );
    }
}
